function bSupportLocalStorage() {
	var mod = 'ctLocalStorageTest',
		bHasSupport = false;
	try {
		localStorage.setItem(mod, mod);
		localStorage.removeItem(mod);
		bHasSupport = true;
	} catch(e) {
		bHasSupport = false;
	}
	if (bHasSupport === false) {
		alert('Nettleseren er ikke satt opp til å støtte lokal lagring av data. For mange enheter kan dette aktiviseres, ta kontakt med Capitech Support.');
	}
}